export default "__VITE_ASSET__04563a87__"